proto = window.Handsontable.Core.prototype # shortcut

# These are some helper functions that I think are really useful but aren't
# available on the HoT instance. (Adapted from the Walkontable class in the
# Handsontable source.)

proto.getFirstRenderedRow = () ->
    return @view.wt.wtViewport.rowsRenderCalculator.startRow

proto.getFirstVisibleRow = () ->
    return @view.wt.wtViewport.rowsVisibleCalculator.startRow

proto.getFirstRenderedColumn = () ->
    return @view.wt.wtViewport.columnsRenderCalculator.startColumn

proto.getFirstVisibleColumn = () ->
    return @view.wt.wtViewport.columnsVisibleCalculator.startColumn

proto.getLastRenderedRow = () ->
    return @view.wt.wtViewport.rowsRenderCalculator.endRow

proto.getLastVisibleRow = () ->
    return @view.wt.wtViewport.rowsVisibleCalculator.endRow

proto.getLastRenderedColumn = () ->
    return @view.wt.wtViewport.columnsRenderCalculator.endColumn

proto.getLastVisibleColumn = () ->
    return @view.wt.wtViewport.columnsVisibleCalculator.endColumn

proto.isRowBeforeViewport = (row) ->
    return (row < @getFirstVisibleRow() and row >= 0)

proto.isRowAfterViewport = (row) ->
    return row > @getLastVisibleRow()

proto.isColumnBeforeViewport = (column) ->
    return (column < @getFirstVisibleColumn() and column >= 0)

proto.isColumnAfterViewport = (column) ->
    return column > @getLastVisibleColumn()

proto.isLastRowFullyVisible = () ->
    return @getLastVisibleRow() is @getLastRenderedRow()

proto.isLastColumnFullyVisible = () ->
    return @getLastVisibleColumn() is @getLastRenderedColumn()

proto.getRenderedColumnsCount = () ->
    if (@view.wt.cloneOverlay instanceof window.WalkontableDebugOverlay)
        return @view.wt.getSetting('totalColumns')
    else if (@view.wt.cloneOverlay instanceof window.WalkontableLeftOverlay or
    @view.wt.cloneOverlay instanceof window.WalkontableCornerOverlay)
        return @view.wt.getSetting('fixedColumnsLeft')
    else
        return @view.wt.wtViewport.columnsRenderCalculator.count


proto.getRenderedRowsCount = () ->
    if (@view.wt.cloneOverlay instanceof window.WalkontableDebugOverlay)
        return @view.wt.getSetting('totalRows')
    else if (@view.wt.cloneOverlay instanceof window.WalkontableTopOverlay or
    @view.wt.cloneOverlay instanceof window.WalkontableCornerOverlay)
        return @view.wt.getSetting('fixedRowsTop')

    return @view.wt.wtViewport.rowsRenderCalculator.count

proto.getVisibleRowsCount = () ->
    return @view.wt.wtViewport.rowsVisibleCalculator.count

proto.allRowsInViewport = () ->
    return @view.wt.getSetting('totalRows') is @getVisibleRowsCount()

proto.getVisibleColumnsCount = () ->
    return @view.wt.wtViewport.columnsVisibleCalculator.count

proto.allColumnsInViewport = () ->
    return @view.wt.getSetting('totalColumns') is @getVisibleColumnsCount()
